<template>
  <div id="cartaporte">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
          <base-material-card color="primary" icon="mdi-truck-check-outline" title="Consulta de CFDI" class="elevation-1 px-5 py-3">
            <v-card-actions>
              <UploadExcel title="Importar Excel Ingreso" idInput="cfdi_ingreso" :on-success="handleSuccess" :before-upload="beforeUpload" :firstRow="2" />

              <v-spacer />
              <v-col cols="12" sm="2" md="2" lg="2" class="text-center">
                <v-select
                  v-model="ejercicio"
                  :items="ejercicios"
                  label="Ejercicio"
                  hide-details
                  dense
                  @change="cargar()"
                ></v-select>
              </v-col>
              <v-spacer />
              <v-col sm="3" md="3" lg="3">
                <v-text-field v-model="id_solicitud" label="Solicitud a Buscar"></v-text-field>
              </v-col>
              <v-btn fab dark x-small color="secondary" @click.native="$local_storage.set($crypto.SHA256('id_solicitud'), $crypto.encrypted(id_solicitud)); cargar();" title="Buscar o Actualizar Estatus" v-tippy>
                <v-icon dark>search</v-icon>
              </v-btn>
         <!--      <v-btn fab dark x-small color="primary" @click.native="cargar" title="Actualizar" v-tippy>
                <v-icon dark>mdi-reload</v-icon>
              </v-btn> -->
              <v-btn fab dark x-small color="info" @click.native="id_solicitud=''; $local_storage.set($crypto.SHA256('id_solicitud'), $crypto.encrypted('')); cargar();" title="Mostrar Todos" v-tippy>
                <v-icon dark>list</v-icon>
              </v-btn>
           <!--     <v-btn  color="red" dark fab x-small title="Cancelar" @click="cancelar2()">
                        <v-icon small>mdi-cancel</v-icon>Todas
                      </v-btn>  -->
            </v-card-actions>
            <v-card-text>
              <div id="datagrid" v-on:keyup.enter="aplicarFiltros()">
                <v-client-table ref="vuetable" :data="items.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                  </template>

                  <template slot="json.Total" slot-scope="props">
                    <div v-if="props.row.json.TipoDeComprobante !='P'">
                      {{props.row.json.Total}}
                    </div>
                    <div v-if="props.row.json.TipoDeComprobante =='P'">
                      {{props.row.json.Complemento.Pagos.Totales.MontoTotalPagos}}
                    </div>
                  </template>

                  <template slot="fecha_timbrado" slot-scope="props">
                    <div>
                      {{props.row.fecha_timbrado!=undefined ?props.row.fecha_timbrado.substring(0, 10):''}}
                    </div>
                  </template>

                  <template slot="json.Fecha" slot-scope="props">
                    <div>
                      {{props.row.json.Fecha != undefined?props.row.json.Fecha.substring(0, 10).replace("T", " ").substring(0, 16):''}}
                    </div>
                  </template>

                  <template slot="estatus" slot-scope="props">
                    <div v-if="getEstatus(props.row.estatus) == 'CANCELADO' || getEstatus(props.row.estatus) == 'ENVIADA A CANCELAR'">
                      <v-btn x-small color="grey darken-1" dark @click="open_modal_cancelado(props.row.id_solicitud)">
                        {{ getEstatus(props.row.estatus) }}
                      </v-btn>
                    </div>
                    <div v-else-if="getEstatus(props.row.estatus) != null && getEstatus(props.row.estatus).indexOf('ERROR') !== -1">
                      <v-btn x-small color="error" @click="modal_error = true; error_texto = getError(props.row.error_solicitud)">
                        {{ getEstatus(props.row.estatus) }}
                      </v-btn>
                    </div>
                    <div v-else>
                      {{ getEstatus(props.row.estatus) }}
                    </div>
                  </template>

                  <template slot="actions" slot-scope="props">
                    <div style="width: 200px !important;">

                      <v-btn v-if="props.row.estatus ==1|| props.row.estatus ==3 || props.row.estatus == 6" color="info" fab x-small title="Descargar PDF" @click="getPDF(props.row.id_solicitud)">
                        <v-icon small>mdi-file-pdf-box</v-icon>
                      </v-btn>
                      <v-btn v-if="props.row.estatus ==1|| props.row.estatus ==3 || props.row.estatus == 6" color="secondary" fab x-small title="Descargar XML" @click="getXML(props.row.id_solicitud, props.row.key_pdf )">
                        <v-icon small>mdi-xml</v-icon>
                      </v-btn>
                      <v-btn v-if="props.row.estatus ==100 " color="red" fab x-small title="Imprimir" @click="print(props.row.id_solicitud)">
                        <v-icon small>mdi-printer-outline</v-icon>
                      </v-btn>

                      <v-btn v-if="(props.row.estatus ==4 || props.row.estatus ==1) && permiso_cancelar " color="red" dark fab x-small title="Cancelar" @click="openmodalcancelar(props.row.id_solicitud)">
                        <v-icon small>mdi-cancel</v-icon>
                      </v-btn>

                      <v-btn v-if="(props.row.estatus ==2 || props.row.estatus ==4 || props.row.estatus ==5 ) && permiso_editar && (props.row.json.TipoDeComprobante=='I' || props.row.json.TipoDeComprobante=='T')  " color="error" fab x-small title="Eliminar Registro"
                        @click="eliminar(props.row.id_solicitud)">
                        <v-icon small>mdi-trash-can</v-icon>
                      </v-btn>
                      <v-btn v-if="(props.row.estatus ==2 || props.row.estatus ==4 || props.row.estatus ==5 ) && permiso_notas && props.row.json.TipoDeComprobante=='E'  " color="error" fab x-small title="Eliminar Registro" @click="eliminar(props.row.id_solicitud)">
                        <v-icon small>mdi-trash-can</v-icon>
                      </v-btn>
                      <v-btn v-if="(props.row.estatus ==2 || props.row.estatus ==4 || props.row.estatus ==5 ) && permiso_pagos && props.row.json.TipoDeComprobante=='P'  " color="error" fab x-small title="Eliminar Registro" @click="eliminar(props.row.id_solicitud)">
                        <v-icon small>mdi-trash-can</v-icon>
                      </v-btn>
                      <v-btn v-if=" (props.row.estatus ==5 || props.row.estatus ==2) && permiso_editar && (props.row.json.TipoDeComprobante=='I' || props.row.json.TipoDeComprobante=='T')  " color="primary" fab x-small title="Reintentar Timbrado, actualiza datos del receptor" @click="reintentar(props.row.id_solicitud)">
                        <v-icon small>mdi-arrow-right</v-icon>
                      </v-btn>
                      <v-btn v-if=" (props.row.estatus ==5 || props.row.estatus ==2) && permiso_pagos && props.row.json.TipoDeComprobante=='P' " color="primary" fab x-small title="Reintentar Timbrado, actualiza datos del receptor" @click="reintentar(props.row.id_solicitud)">
                        <v-icon small>mdi-arrow-right</v-icon>
                      </v-btn>
                      <v-btn v-if=" (props.row.estatus ==5 || props.row.estatus ==2) && permiso_notas && props.row.json.TipoDeComprobante=='E' " color="primary" fab x-small title="Reintentar Timbrado, actualiza datos del receptor" @click="reintentar(props.row.id_solicitud)">
                        <v-icon small>mdi-arrow-right</v-icon>
                      </v-btn>
                      <v-btn v-if=" props.row.estatus ==3 || props.row.estatus == 6" color="red" fab x-small dark title="Descargar Acuse XML Cancelado" @click="getAcuseXML(props.row.id_solicitud, props.row.key_pdf)">
                        <v-icon small>mdi-xml</v-icon>
                      </v-btn>
                      <v-btn v-if="props.row.estatus ==1 || props.row.estatus ==3" color="warning" dark fab x-small title="Enviar Por Correo" @click="mostrar_correo(props.row.id_solicitud, props.row.cliente, props.row.json)">
                        <v-icon small>mdi-email-fast</v-icon>
                      </v-btn>
                      <v-btn v-if="props.row.estatus ==1 " color="orange" dark fab x-small title="Regenerar PDF" @click="regenerar(props.row.id_solicitud)">
                        <v-icon small>mdi-cogs</v-icon>
                      </v-btn>
                      <v-btn v-if="props.row.estatus ==2 && nombre=='Admin'" color="pink" dark fab x-small title="Regenerar JSON" @click="regenerarjson(props.row)">
                        <v-icon small>mdi-cog</v-icon>
                      </v-btn>
                      <v-btn v-if="nombre=='Admin' && props.row.id_solicitud == regenera_json.id_solicitud" dark fab x-small color="success" @click.native="reenvia_json()">
                                              <v-icon>done</v-icon>
                      </v-btn>

                    <v-btn v-if="( props.row.estatus ==6) " color="red" dark fab x-small title="Reenviar a Cancelar" @click="openmodalcancelar(props.row.id_solicitud)">
                        <v-icon small>mdi-arrow-right</v-icon>
                      </v-btn>
                        <v-btn v-if="( props.row.estatus ==6) " color="purple" fab x-small title="Consultar Estatus CFDI" @click="consultar_estatus_cfdi(props.row.id_solicitud)" style="color:white">
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                      <UploadExcel  v-if=" (props.row.estatus ==1|| props.row.estatus ==3) && (props.row.json.TipoDeComprobante=='I') && props.row.json.InformacionGlobal != undefined"  icon="mdi-note-text" title="Agregar Nota de Crédito"  idInput="'cfdi' + props.row.id_solicitud"  @click.native="actual(props.row.json)" :on-success="handleSuccess2" :before-upload="beforeUpload" :firstRow="2" />

                       </div>
                  </template>
                </v-client-table>
                <template>
                  <div v-if="pwPagination.total > 0" >
                    <div class="mt-3">
                      <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="items" :options="pwPagination.options"></PaginacionComponent>
                    </div>
                  </div>
                </template>
              </div>

              <v-dialog v-model="modal_cancelar" max-width="700px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Cancelar CFDI</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form ref="formempresa">
                        <v-card width="100%">
                          <v-card-text>
                            <h5>¿Realmente desea cancelar el CFDI?</h5>
                            <v-autocomplete v-model="motivo" label="Debe especificar el Motivo de Cancelación" :items="motivos" :hide-no-data="true" item-text="nombre" item-value="clave">
                            </v-autocomplete>

                            <v-text-field v-if="motivo=='01'" label="Folio Sustituto" v-model="folio_sustituto" :rules="[rules.required, validaFolio]" />
                          </v-card-text>
                        </v-card>

                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="default" @click="modal_cancelar=false">
                      <v-icon small>mdi-cancel</v-icon> NO
                    </v-btn>
                    <v-btn color="success" @click="cancelar()" :disabled="motivo == ''">
                      <v-icon small>mdi-check-circle-outline</v-icon> SI
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>

    </v-container>

    <v-dialog v-model="modalCorreo" max-width="50%">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon class="white--text">email</v-icon>&nbsp;
            <span class="subheading">
              <strong>Enviar por Correo</strong>
            </span>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="modalCorreo = false" class="close_modal">
            <v-icon class="white--text">cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="formcorreo" lazy-validation>
            <v-container>
              <v-row>
                <v-col>
                  <!-- <v-checkbox v-model="check_cliente" label="Correo Cliente" :true-value="1" :false-value="0" @change="set_correo_cliente()"></v-checkbox> -->
                </v-col>
                <v-col>
                  <v-checkbox v-model="check_receptor" label="Correo Receptor" :true-value="1" :false-value="0" @change="set_correo_receptor()"></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="Enviar a" v-model="correo.correos" persistent-hint hint="Correos separados por coma" :rules="[rules.required, validaCorreo]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="Asunto" v-model="correo.asunto" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="Texto del Correo" v-model="correo.mensaje" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
              <!--   <v-row>
                <v-col>
                  <v-text-field label="Responder a" v-model="correo.responder_a" persistent-hint hint="Correos separados por coma" :rules="[rules.required, validaCorreo]"></v-text-field>
                </v-col>
              </v-row> -->
              <v-row justify="center">
                &nbsp;
              </v-row>
              <v-row justify="center">
                <v-btn small @click.native="modalCorreo = false">
                  <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                &nbsp;&nbsp;
                <v-btn small color="success" @click.native="enviarCorreo()">
                  <v-icon>done</v-icon> Enviar
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_detalles_cancelacion" max-width="30%">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon class="white--text">note</v-icon>&nbsp;
            <span class="subheading">
              <strong>Detalles de la Cancelación</strong>
            </span>
          </v-card>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <table width="100%">
                <tbody>
                  <tr>
                    <th>Motivo Cancelación</th>
                    <td v-if="model_detalles_cancelacion != null">{{ get_motivo_cancelacion(model_detalles_cancelacion.motivo) }}</td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th>Folio Sustituto</th>
                    <td>{{ model_detalles_cancelacion.folio_sustituto == null ? 'N/A': model_detalles_cancelacion.folio_sustituto }}</td>
                  </tr>
                </tbody>
              </table>
            </v-row>
          </v-container>
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog v-model="modal_error" max-width="50%">
      <v-card>
        <v-card-title>
          <v-card class="error white--text titulomodal">
            <v-icon class="white--text">mdi-alert-circle</v-icon>&nbsp;
            <span class="subheading"><strong>Detalle del Error</strong></span>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="modal_error = false" class="close_modal">
            <v-icon class="white--text">cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <p style="white-space: pre-wrap; word-break: break-word;">{{ error_texto }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" @click="modal_error = false">
            <v-icon small>mdi-close</v-icon> Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <pre  v-if=" nombre=='Admin'">{{ regenera_json }}</pre>

  </div>
  </template>

  <script>
  import moment from "moment";
  import axios from "axios";
  import PaginacionComponent from '@/components/PaginacionComponent.vue';
  import UploadExcel from '@/components/UploadExcel/UploadExcel.vue';

  export default {
    components: {
      "PaginacionComponent": PaginacionComponent,
      "UploadExcel": UploadExcel,
    },
    name: "DashboardDataTables",
    mounted: function() {
      this.model_filters = this.$refs.vuetable.query;
      this.cargarEjercicios();
    },
    data: () => ({
      modal_error: false,
      error_texto: "",
      modal_detalles_cancelacion:false,
      model_detalles_cancelacion:{},
      regenera_json:"",
      errores_webservice:[],
      cfdis:[],
      r_actual:{},
      emisor_completo: {},
      tabla: "carta_porte",
      params: "",
      folio_sustituto: null,
      id_solicitud_correo: "",
      check_cliente: 0,
      check_receptor: 1,
      correo_receptor: "",
      correo_cliente: [],
      modalCorreo: false,
      correo: {
        correos: "",
        responder_a: "contacto@power-devel.com",
        asunto: "Factura:",
        mensaje: "Se adjunta PDF y XML de su factura."
      },
      url: 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/',
      // url: 'http://localhost:8000/',
      URL_SAT: "",
      s_origen: false,
      emisor: "",
      model_filters: "",
      pwPagination: {
        total: 0,
        links: {
          url: '',
          next: '',
          prev: '',
        },
        options: {
          tipo: 1,
          size: 10,
          filters: {}
        }
      },
      id_solicitud: "",
      id_solicitud_cancelado: "",
      motivo: "",
      modal_cancelar: false,
      s_destino: false,
      hora_salida: "",
      hora_llegada: "",
      origen: {},
      destino: {},
      origenes: [],
      destinos: [],
      receptores: [],
      receptor: {},
      id_empresa: "",
      id_licencia: "",
      modal: false,
      usuario: "",
      clientes: [],
      por_pagar: [],
      menu1: false,
      compartir_clientes: "",
      indexSeleccionado: "x",
      ejercicio: new Date().getFullYear(),
      ejercicios: [],
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home",
        },
        {
          text: "CFDI",
          disabled: true,
          href: "",
        },
      ],
      estatus: [{
        "estatus": "Activo"
      }, {
        "estatus": "Inactivo"
      }],
      model: {
        id_solicitud: "",
        uuid_empresa: "",
        uuid_licencia: "",
        cliente: "",
        error_pdf: "",
        error_solicitud: "",
        estatus: "",
        fecha_timbrado: "",
        fecha_timbrado: "",
        json: {},
        key_pdf: "",
      },
      emptymodel: {
        id_solicitud: "",
        uuid_empresa: "",
        uuid_licencia: "",
        cliente: "",
        error_pdf: "",
        error_solicitud: "",
        estatus: "",
        fecha_timbrado: "",
        fecha_timbrado: "",
        json: {},
        key_pdf: "",
      },
      updateModel: false,
      rules: {},
      motivos: [{
          clave: "01",
          nombre: "Comprobantes emitidos con errores con relación"
        },
        {
          clave: "02",
          nombre: "Comprobantes emitidos con errores sin relación"
        },
        {
          clave: "03",
          nombre: "No se llevó a cabo la operación"
        },
        {
          clave: "04",
          nombre: "Operación nominativa relacionada en una factura global"
        }
      ],
      columns: ["id_solicitud", "fecha_timbrado", "json.TipoDeComprobante", "json.Fecha", "json.Complemento.TimbreFiscalDigital.UUID", "json.Receptor.Rfc", "json.Receptor.Nombre", "json.Serie", "json.Folio", "json.Total",
        "estatus", "actions"
      ],
      options: {
        filterable: ["id_solicitud", "fecha_timbrado", "json.Complemento.TimbreFiscalDigital.UUID", "json.TipoDeComprobante", "json.Fecha", "json.Receptor.Rfc", "json.Receptor.Nombre", "json.Serie", "json.Folio", "json.Total", "estatus"],
        sortable: ["id_solicitud", "fecha_timbrado", "json.Complemento.TimbreFiscalDigital.UUID", "json.TipoDeComprobante", "json.Fecha", "json.Receptor.Rfc", "json.Receptor.Nombre", "json.Serie", "json.Folio", "json.Total", "estatus"],
        filterByColumn: true,
        listColumns: {
          estatus: [{
              "id": 0,
              "text": "CREADO"
            },
            {
              "id": 1,
              "text": "TIMBRADO"
            },
            {
              "id": 2,
              "text": "ERROR"
            },
            {
              "id": 3,
              "text": "CANCELADO"
            },
            {
              "id": 4,
              "text": "ERROR PAQ"
            },
            {
              "id": 5,
              "text": "ERROR PAQ DE TIMBRADO"
            },
            {
              "id": 6,
              "text": "ENVIADA A CANCELAR"
            }
          ]
        },

        headings: {
          id_solicitud: "Solicitud",
          "json.Complemento.TimbreFiscalDigital.UUID": "UUID",
          "json.TipoDeComprobante": "Tipo",
          "fecha_timbrado": "Fecha Timbrado",
          "json.Receptor.Rfc": "RFC",
          "json.Receptor.Nombre": "Destino",
          "json.Fecha": "Fecha Factura",
          "json.Serie": "Serie",
          "json.Folio": "Folio",
          "json.Total": "Total",
          estatus: "Estatus",
          actions: "Operaciones"
        },
        customFilters: [{
          name: 'estatus',
          callback: function(row, query) {
            return row.estatus == query;
          }
        }]

      },
      export_excel: {
        "Solicitud": "id_solicitud",
        "UUID": "json.Complemento.TimbreFiscalDigital.UUID",
        "Tipo": "json.TipoDeComprobante",
        "Fecha Creación": "fecha_timbrado",
        "RFC": "json.Receptor.Rfc",
        "Destino": "json.Receptor.Nombre",
        "Fecha Timbrado": "json.Fecha",
        "Serie": "json.Serie",
        "Folio": "json.Folio",
        "Total": "json.Total",
        "Error": "error_solicitud",
        "Estatus": "estatus"
      },
      items: {
        items: []
      },
      search: undefined,
    }),
    computed: {
      tituloModal() {
        return this.updateModel === false ? "Nueva Carta Porte" : "Editar Carta Porte";
      },
      permiso_editar() {
        return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.nueva'))) == '1';
      },
      permiso_pagos() {
        return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.pagos'))) == '1';
      },
      permiso_notas() {
        return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.notas'))) == '1';
      },
      permiso_cancelar() {
        return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.cancelar'))) == '1';
      },
      datafiltered() {

        let result = [];
        if (this.$refs.vuetable != null) {
          result = this.$refs.vuetable.allFilteredData;
          return result;
        } else {
          result = this.items;
          return result;
        }
      },
      nombre() {


      let nombre_usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));

      return nombre_usuario;


      }, empresa() {
        let empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_empresa")));
        if (empresa)
          return empresa;
        else
          return "";
      },
    },
    methods: {

      // Llena el combo "Ejercicio" con los ultimos 10 anios en orden
      // descendente (del actual hacia atras) y deja el actual por defecto.
      cargarEjercicios: function() {
        let anioActual = new Date().getFullYear();
        let anios = [];
        for (let i = 0; i < 10; i++) {
          anios.push(anioActual - i);
        }
        this.ejercicios = anios;
        this.ejercicio = anioActual;
      },

      // Escapa los caracteres especiales de regex para que la busqueda del
      // usuario se trate como texto literal y no rompa la consulta.
      escapeRegex: function(value) {
        return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      },

      // Regex anclado al inicio (busqueda por prefijo). Un patron anclado puede
      // apoyarse en indices de MongoDB, a diferencia de un "contains" sin ancla.
      prefixRegex: function(value) {
        return { '$regex': '^' + this.escapeRegex(value), '$options': 'i' };
      },

      // Regex sin ancla (contiene). Usar solo cuando la busqueda parcial es
      // realmente necesaria (ej. nombre del receptor).
      containsRegex: function(value) {
        return { '$regex': this.escapeRegex(value), '$options': 'i' };
      },

      // Construye el objeto de filtros unicamente en el momento de filtrar,
      // evitando reconstruirlo en cada pulsacion de tecla.
      buildFilters: function() {
        let filtros = {};
        let f = this.model_filters || {};



        // Busqueda exacta (igualdad directa, sin regex).
        if (f.id_solicitud) {
          filtros.id_solicitud = f.id_solicitud;
        }
        if (f['json.Folio']) {
          filtros["json.Folio"] = f['json.Folio'];
        }
        if (f['json.Serie']) {
          filtros["json.Serie"] = f['json.Serie'];
        }
        if (f['json.Complemento.TimbreFiscalDigital.UUID']) {
          filtros["json.Complemento.TimbreFiscalDigital.UUID"] = f['json.Complemento.TimbreFiscalDigital.UUID'];
        }
        if (f["json.Receptor.Rfc"]) {
          filtros["json.Receptor.Rfc"] = f["json.Receptor.Rfc"];
        }
        if (f['json.TipoDeComprobante']) {
          filtros["json.TipoDeComprobante"] = f['json.TipoDeComprobante'];
        }
        if (f.estatus) {
          filtros.estatus = parseInt(f.estatus);
        }
        if (f.fecha_timbrado) {
          filtros.fecha_timbrado = f.fecha_timbrado;
        }
        if (f['json.Total']) {
          filtros["json.Total"] = f['json.Total'];
        }

        // Busqueda parcial (contiene): campos de texto libre.
        // json.Receptor.Nombre: sin $options; se envia el valor en MAYUSCULAS
        // para coincidir con los nombres almacenados.
        if (f["json.Receptor.Nombre"]) {
          filtros["json.Receptor.Nombre"] = { '$regex': this.escapeRegex(String(f["json.Receptor.Nombre"]).toUpperCase()) };
        }
        if (f.error_solicitud) {
          filtros.error_solicitud = this.containsRegex(f.error_solicitud);
        }
        // Filtro por ejercicio (siempre presente) sobre json.Fecha:
        // trae solo los registros cuyo json.Fecha empieza con el anio
        // seleccionado (formato YYYY-...). Si ademas el usuario escribe en la
        // columna json.Fecha, se combina ambas condiciones.
        if (this.ejercicio && f["json.Fecha"]) {
          // El usuario afina dentro del anio: anclamos al anio y luego el texto.
          filtros["json.Fecha"] = { '$regex': '^' + this.ejercicio + '.*' + this.escapeRegex(f["json.Fecha"]) };
        } else if (this.ejercicio) {
          filtros["json.Fecha"] = { '$regex': '^' + this.ejercicio };
        } else if (f["json.Fecha"]) {
          filtros["json.Fecha"] = this.prefixRegex(f["json.Fecha"]);
        }

        this.pwPagination.options.filters = {
          filtros: filtros,
          cliente: this.emisor,
          campos: {
            "id_solicitud": 1,
            "json.Complemento.TimbreFiscalDigital.UUID": 1,
            "json.TipoDeComprobante": 1,
            "fecha_timbrado": 1,
            "json.Receptor": 1,
            "json.Fecha": 1,
            "json.Serie": 1,
            "json.Folio": 1,
            "json.Total": 1,
            "json.Complemento.Pagos": 1,
            "error_solicitud": 1,
            "estatus": 1,
            "key_pdf": 1,
            "json.InformacionGlobal": 1
          }
        };
      },

      // Punto unico de entrada del filtrado: arma los filtros y dispara la
      // consulta en el componente de paginacion.
      aplicarFiltros: function() {
        this.buildFilters();
        if (this.$refs.pagination_pw) {
          this.$refs.pagination_pw.filterData();
        }
      },

      openmodalcancelar: function(id) {
        this.id_solicitud_cancelado = id;
        this.modal_cancelar = true;
      },
      getIndex: function(item) {
        const search = (element) => element.folio == item.folio && element.uuid_licencia == item.uuid_licencia;
        var idx = this.items.items.findIndex(search);
        return idx;
      },
      getEstatus(index) {
        let estatus = ["ENVIADO", "TIMBRADO", "ERROR", "CANCELADO", "ERROR PAQ", "ERROR PAQ DE TIMBRADO", "ENVIADA A CANCELAR"];
        return estatus[index];
      },
      async regenerarjson(row) {


        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;

        var data = {
          "id_solicitud": row.id_solicitud,
          "detalle" : true,
          "campos":{'id_solicitud':1, 'json':1}
        };
        let URL = this.$hostname + "carta_porte/catalogos/";
        axios.post(self.url + 'carta_porte/solicitud_mongo/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {

            self.regenera_json = res.data;
            self.regenera_json.json.Complemento.Pagos.Totales.TotalRetencionesIVA = "0.00";
            self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosBaseIVA16 = "0.00";
            self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosImpuestoIVA16 = "0.00";
            self.regenera_json.json.Fecha = moment().format("YYYY-MM-DD") + "T00:00:00";


            self.regenera_json.json.Complemento.Pagos.Pago[0].DoctoRelacionado.forEach(async function(x){

              var data = {
                  "cliente": self.emisor,
                  "filtros": {
                    "json.Complemento.TimbreFiscalDigital.UUID": {
                        '$regex': x.IdDocumento,
                        '$options': 'i'
                      },
                  }
              };
              await axios.post(self.url + 'carta_porte/list_carta_porte/', data)
                  .then((res) => {

                    if(x.ImpuestosDR.RetencionesDR != undefined){
                      x.ImpuestosDR.RetencionesDR[0].BaseDR = parseFloat(res.data.results[0].json.SubTotal).toFixed(2);
                      x.ImpuestosDR.RetencionesDR[0].ImporteDR = (parseFloat(res.data.results[0].json.SubTotal) * parseFloat(x.ImpuestosDR.RetencionesDR[0].TasaOCuotaDR)).toFixed(2);
                      self.regenera_json.json.Complemento.Pagos.Totales.TotalRetencionesIVA = (parseFloat(self.regenera_json.json.Complemento.Pagos.Totales.TotalRetencionesIVA) + parseFloat(x.ImpuestosDR.RetencionesDR[0].ImporteDR)).toFixed(2);
                      self.regenera_json.json.Complemento.Pagos.Pago[0].ImpuestosP.RetencionesP[0].ImporteP = parseFloat(self.regenera_json.json.Complemento.Pagos.Totales.TotalRetencionesIVA.toFixed(2));

                    }
                    if(x.ImpuestosDR.TrasladosDR != undefined){
                        x.ImpuestosDR.TrasladosDR[0].TasaOCuotaDR = (parseFloat(x.ImpuestosDR.TrasladosDR[0].TasaOCuotaDR)).toFixed(6);
                        x.ImpuestosDR.TrasladosDR[0].BaseDR = parseFloat(res.data.results[0].json.SubTotal).toFixed(2);
                        x.ImpuestosDR.TrasladosDR[0].ImporteDR = (parseFloat(res.data.results[0].json.SubTotal) * parseFloat(x.ImpuestosDR.TrasladosDR[0].TasaOCuotaDR)).toFixed(2);
                        self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosBaseIVA16 = (parseFloat(self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosBaseIVA16) + parseFloat(x.ImpuestosDR.TrasladosDR[0].BaseDR)).toFixed(2);
                        self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosImpuestoIVA16 = (parseFloat(self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosImpuestoIVA16) +  parseFloat(x.ImpuestosDR.TrasladosDR[0].ImporteDR)).toFixed(2);
                        self.regenera_json.json.Complemento.Pagos.Pago[0].ImpuestosP.TrasladosP[0].BaseP = self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosBaseIVA16;
                        self.regenera_json.json.Complemento.Pagos.Pago[0].ImpuestosP.TrasladosP[0].ImporteP = self.regenera_json.json.Complemento.Pagos.Totales.TotalTrasladosImpuestoIVA16;

                    }


                  });



        });
            if (self.regenera_json.json.Complemento.Pagos.Totales.TotalRetencionesIVA == "0.00"){
              delete self.regenera_json.json.Complemento.Pagos.Totales.TotalRetencionesIVA;
            }
            }
            self.$root.$dialogLoader.hide();
          })
          .catch((error) => {
            console.log(error);
            self.$root.$dialogLoader.hide();

          });











      },
      getErroresWebservice: async function(){

          let self = this;
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          await this.$axios.post(this.url+"carta_porte/administracion/list_errores/")
            .then(res => {
              this.errores_webservice = res.data;
            }).catch(err => {
              self.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al obtener catalogo de errores.",
                footer: "",
              });
              console.log(err);
            }).then(() => {
              self.$root.$dialogLoader.hide();
            });
      },
      getError(error){
        try {
            var result = error;

            if(error && error!="" && error!=null){
                var filtro = this.errores_webservice.find(e => error.toString().toLowerCase().indexOf(e.error.toString().toLowerCase()) != -1);
                if(filtro)
                  result = filtro.descripcion;
            }

            return result;

        } catch (error) {
            return result;
        }

      },
      parseDate(date) {
        //Formato  YYYY-MM-DD
        if (!date) return null;
        return moment(String(date)).format("YYYY-MM-DD");
      },
      actual(row){
        this.r_actual = row
        //row.Complemento.TimbreFiscalDigital.UUID;
        console.log(this.r_actual );
      },
      eliminar: function(id) {
        var self = this;
        self.$swal({
          type: "info",
          title: "Cuidado",
          text: "¿Está seguro de eliminar el registro?",
          footer: "",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (result.value) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var params = {
              "id_solicitud": id
            };

            this.$axios.post(this.url + "carta_porte/eliminar_mongo/", params)
              .then(res => {
                self.$swal({
                  type: "success",
                  title: "¡Operación Exitosa!",
                  text: "El registro se eliminó correctamente.",
                  footer: "",
                });
                self.cargar();
              })
              .catch(err => {
                this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al eliminar el registro.",
                  footer: "",
                });
                console.log(err);
              }).then(() => {
                self.$root.$dialogLoader.hide();
              });
          }
        });

      },

      cancelar2(){
        let lista = [
          'GCA740122352-1693958030604153',
  'GCA740122352-16939579500686102',
  'GCA740122352-16939578983542516',
  'GCA740122352-16939578108922632',
  'GCA740122352-16939577410513928',
  'GCA740122352-16939576829064696',
  'GCA740122352-16939576286605916',
  'GCA740122352-16939575742633314',
  'GCA740122352-16939575135433056',
  'GCA740122352-169395746366329',
  'GCA740122352-16939573228820198',
  'GCA740122352-16939572387047637',
  'GCA740122352-16939571897178965',
  'GCA740122352-1693957119422612',
  'GCA740122352-1693957026437454',
  'GCA740122352-1693956963877963',
  'GCA740122352-1693956892897574',
  'GCA740122352-16939561762983575',
  'GCA740122352-1693956125840032',
  'GCA740122352-16939560777208576',
  'GCA740122352-16939560240945313',
  'GCA740122352-1693955980897321',
  'GCA740122352-16939559280574787',
  'GCA740122352-16939558772531648',
  'GCA740122352-16939558223631825',
  'GCA740122352-1693955773999308',
  'GCA740122352-16939556972689083',
  'GCA740122352-16939556333656964',
  'GCA740122352-16939555881209192',
  'GCA740122352-16939555365757732',
  'GCA740122352-169395548827665',
  'GCA740122352-16939554397931385',
  'GCA740122352-16939553825765274',
  'GCA740122352-16939553349921741',
  'GCA740122352-1693955290862185',
  'GCA740122352-16939552419531438',
  'GCA740122352-16939551685407863',
  'GCA740122352-16939551260151515',
  'GCA740122352-16939550814901416',
  'GCA740122352-16939550313662877',
  'GCA740122352-16939549845530593',
  'GCA740122352-16939549310083623',
  'GCA740122352-1693954886435526',
  'GCA740122352-16939548397861485',
  'GCA740122352-16939547937930498',
  'GCA740122352-16939547290940075',
  'GCA740122352-16939546540357325',
  'GCA740122352-16939545991208057',
  'GCA740122352-1693954548548238',
  'GCA740122352-1693954497382901',
  'GCA740122352-16939544427892866',
  'GCA740122352-16939520826756976',
  'GCA740122352-1693952029381825',
  'GCA740122352-16939519862038095',
  'GCA740122352-1693951748906578',
  'GCA740122352-1693951701083883',
  'GCA740122352-16939516598515744',
  'GCA740122352-16939516148244612',
  'GCA740122352-169395156898245',
  'GCA740122352-16939515124268944',
  'GCA740122352-1693951455220928',
  'GCA740122352-1693951406789842',
  'GCA740122352-16939510638062403',
  'GCA740122352-1693951001662679',
  'GCA740122352-1693950950825436',
  'GCA740122352-16939508999469638',
  'GCA740122352-169395084946151',
  'GCA740122352-16939507914478395',
  'GCA740122352-1693950651163341',
  'GCA740122352-16939505977170014',
  'GCA740122352-16939505130051599',
  'GCA740122352-16939504650591345',
  'GCA740122352-16939504181008894',
  'GCA740122352-169395024165413',
  'GCA740122352-16939501896113234',
  'GCA740122352-1693950124869802',
  'GCA740122352-16939500752090266',
  'GCA740122352-16939500258304393',
  'GCA740122352-16939498586432471',
  'GCA740122352-16939497923420653',
  'GCA740122352-16939497434425695',
  'GCA740122352-16939496870211043',
  'GCA740122352-16939496074417465',
  'GCA740122352-16939495373799527',
  'GCA740122352-16939494726564345',
  'GCA740122352-16939494049154406',
  'GCA740122352-16939493471769612',
  'GCA740122352-16939491697525988',
  'GCA740122352-16939490317851713',
  'GCA740122352-16939489190028362',
  'GCA740122352-169394886216221',
  'GCA740122352-16939488046795635',
  'GCA740122352-16939487201626148',
  'GCA740122352-16939486405850341',
  'GCA740122352-16939482642586472',
  'GCA740122352-16939480259380753',
  'GCA740122352-1693947969864354',
  'GCA740122352-16939479066292868',
  'GCA740122352-1693947694513462',
  'GCA740122352-1693947630130896',
  'GCA740122352-16939475638767753',
  'GCA740122352-1693947484677845',
  'GCA740122352-16939473771392677',
  'GCA740122352-16939473026287467',
  'GCA740122352-1693947224748842',
  'GCA740122352-16939471528652105',
  'GCA740122352-16939470924683971',
  'GCA740122352-16939470315790803',
  'GCA740122352-16939469608974435',
  'GCA740122352-16939468809171894',
  'GCA740122352-16939468236850204',
  'GCA740122352-16939467623215766',
  'GCA740122352-16939466884618273',
  'GCA740122352-16939464123564677',
  'GCA740122352-16939463442371953',
  'GCA740122352-16939462178273108',
  'GCA740122352-16939459996647265',
  'GCA740122352-1693945861277477',
  'GCA740122352-16939457796582396',
  'GCA740122352-16939456957994485',
  'GCA740122352-16939456468045719',
  'GCA740122352-16939455873127344',
  'GCA740122352-1693945514758123',
  'GCA740122352-16939454076103222',
  'GCA740122352-16939453459958296',,
          ];
          var self = this;
          lista.forEach(function(x){


        var data = {
          "id_solicitud": x,
          "motivo": '02'
        };

              axios.post(self.url + 'carta_porte/cancelar_mongo/', data)
                .then((res) => {
                  console.log(x);
                })
                .catch((error) => {
                  console.log(error);
                });
        });
        console.log('fin');
      },
      cancelar: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;

      var data = {
        "id_solicitud": this.id_solicitud_cancelado,
        "motivo": this.motivo
      };

      if (this.motivo == '01') {
        data.folio_sustituto = this.folio_sustituto;
      }

      axios.post(self.url + 'carta_porte/cancelar_mongo/', data)
        .then((res) => {
          if (typeof res.data !== 'undefined') {

            self.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "El registro se envio cancelar correctamente. ",
              footer: "",
            });

            self.$root.$dialogLoader.hide();
            self.cargar();
            self.modal_cancelar = false;
            self.folio_sustituto = null;
            self.motivo = null;
          }
        })
        .catch((error) => {
          console.log(error);
          self.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al cancelar el registro.",
            footer: "",
          });
          self.$root.$dialogLoader.hide();
          self.cargar();
          self.modal_cancelar = false;
          self.folio_sustituto = null;
          self.motivo = null;
        });



    },
      cargar: function() {
        var self = this;
        this.$root.$dialogLoader.show("Espere un momento por favor..");

        if (self.emisor.length > 0) {
          // Construye options.filters (ejercicio + columnas + campos) desde una
          // sola fuente, de modo que la paginacion reutilice exactamente lo
          // mismo que la carga inicial.
          this.buildFilters();

          // Busqueda directa por id_solicitud desde el encabezado.
          if (self.id_solicitud.length > 0) {
            this.pwPagination.options.filters.id_solicitud = self.id_solicitud;
          } else {
            delete this.pwPagination.options.filters.id_solicitud;
          }

          this.params = this.pwPagination.options.filters;
        }


        this.$axios.post(this.url + "carta_porte/list_carta_porte/", this.params)
          .then(res => {
            self.items.items = res.data.results;

            // if (self.items.items.length > 0)
            // self.items.items.forEach(function(i) {
            //   i.estatus = self.getEstatus(i.estatus);
            //   i.fecha_timbrado = i.fecha_timbrado.replace("T", " ").substring(0, 16);
            //   i.json.Fecha = i.json.Fecha.substring(0, 10);
            //
            // })
            self.pwPagination.total = res.data.count;
            self.pwPagination.links.next = res.data.next;
            self.pwPagination.links.prev = res.data.previous;
            self.$root.$dialogLoader.hide();
          })
          .catch(err => {
            self.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al obtener los registros.",
              footer: "",
            });
            console.log(err);
          }).then(() => {
            self.$root.$dialogLoader.hide();
          });
      },

      getPDF: function(id) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;
        var data = {
          id_solicitud: id,
        };
        axios.post(this.url + 'carta_porte/get_url_pdf_mongo/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              axios({
                  method: 'get',
                  url: res.data,
                  responseType: 'arraybuffer'
                })
                .then(response => {

                  this.forceFileDownload(response, id + ".pdf")
                  self.$root.$dialogLoader.hide();
                })
                .catch(() => console.log('error occured'))
              self.$root.$dialogLoader.hide();
            }
          })
          .catch((error) => {
            console.log(error);
            self.$root.$dialogLoader.hide();
          });
      },
      getXML: function(id, file) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;

        var data = {
          key: file.replace('pdf', 'xml'),
        };
        axios.post(this.url + 'carta_porte/get_download_url_mongo/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              axios({
                  method: 'get',
                  url: res.data,
                  responseType: 'arraybuffer'
                })
                .then(response => {

                  this.forceFileDownload(response, id + ".xml")
                  self.$root.$dialogLoader.hide();
                })
                .catch(() => console.log('error occured'))
              self.$root.$dialogLoader.hide();
            }
          })
          .catch((error) => {
            console.log(error);
            self.$root.$dialogLoader.hide();
          });
      },
      getAcuseXML: function(id, file) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;
        let f = file.replace('pdf', 'xml');
        f = f.replace(id, 'cancelado_' + id);
        var data = {
          key: f,
        };

        axios.post(this.url + 'carta_porte/get_download_url_mongo/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              axios({
                  method: 'get',
                  url: res.data,
                  responseType: 'arraybuffer'
                })
                .then(response => {

                  this.forceFileDownload(response, "Acuse_" + id + ".xml")
                  self.$root.$dialogLoader.hide();
                })
                .catch(() => console.log('error occured'))
              self.$root.$dialogLoader.hide();
            }
          })
          .catch((error) => {
            console.log(error);
            self.$root.$dialogLoader.hide();
          });
      },
      forceFileDownload(response, name) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name) //or any other extension
        document.body.appendChild(link)
        link.click()
      },
      reintentar: function(id) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;

        var data = {
          "id_solicitud": id,
          "detalle" : true,
          "campos":{'json':1}
        };
        let URL = this.$hostname + "carta_porte/catalogos/";
        axios.post(self.url + 'carta_porte/solicitud_mongo/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              var json = res.data.json;
           //   console.log(res.data.json.Receptor);
              let cliente = res.data.json.Receptor.Rfc;
              var data2 = {
                            uuid_empresa: this.id_empresa,
                            rfc: res.data.json.Receptor.Rfc
                          };
                          this.$axios.post(URL  + "list_clientes/", data2)
                            .then(res2 => {
                              if (typeof res2.data !== "undefined") {
                                var filter =res2.data;
                             //   console.log(filter);
                                if(filter.length > 0){
                                  json.Receptor.Nombre = filter[0].nombre;
                                  json.Receptor.RegimenFiscalReceptor = filter[0].regimen_fiscal_receptor;
                                  json.Receptor.DomicilioFiscalReceptor = filter[0].domicilio.codigo_postal;
                                  json.Receptor.Email = filter[0].email;
                                  json.Receptor.Domicilio = {};
                                  json.Receptor.Domicilio.Calle= filter[0].domicilio.calle;
                                  json.Receptor.Domicilio.CodigoPostal= filter[0].domicilio.codigo_postal;
                                  json.Receptor.Domicilio.Colonia= filter[0].domicilio.colonia;
                                  json.Receptor.Domicilio.Estado= filter[0].domicilio.estado;
                                  json.Receptor.Domicilio.Localidad= filter[0].domicilio.localidad;
                                  json.Receptor.Domicilio.Municipio= filter[0].domicilio.municipio;
                                  json.Receptor.Domicilio.NumeroExterior= filter[0].domicilio.numero_ext;
                                  json.Receptor.Domicilio.Pais= filter[0].domicilio.pais;
                                  json.Receptor.Domicilio.Referencia= "";
                                }
                              //    console.log(json);
                                  var data3 = {
                                        "id_solicitud": id,
                                        "json": json
                                      };
                                      axios.post(self.url + 'carta_porte/reintentar/', data3)
                                        .then((res3) => {
                                          if (typeof res3.data !== 'undefined') {
                                           //console.log(res3.data);
                                            self.$swal({
                                              type: "success",
                                              title: "¡Operación Exitosa!",
                                              text: "El registro se envio correctamente. ",
                                              footer: "No. de Solicitud: " + id,
                                            });
                                            self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(id));
                                           // self.$router.replace("/cartaporte");
                                           self.cargar();
                                            self.$root.$dialogLoader.hide();
                                          }
                                        })
                                        .catch((error) => {
                                          console.log(error);
                                          self.$root.$dialogLoader.hide();
                                          self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(''));
                                          self.$swal({
                                            type: "error",
                                            title: "Error",
                                            text: "Ocurrió un error al enviar el registro.",
                                            footer: "Intente nuevamente mas tarde",
                                          });
                                          self.cargar();
                                        });



                              }
                            })
                            .catch(err => {

                              console.log(err);
                            });

            }
            self.$root.$dialogLoader.hide();
          })
          .catch((error) => {
            console.log(error);
            self.$root.$dialogLoader.hide();

          });

      },
      reenvia_json: function(id) {
        let self = this;
              var data3 = {
                "id_solicitud": this.regenera_json.id_solicitud,
                "json": this.regenera_json.json
              };
              axios.post(self.url + 'carta_porte/reintentar/', data3)
                .then((res3) => {
                  if (typeof res3.data !== 'undefined') {
                    //console.log(res3.data);
                    self.$swal({
                      type: "success",
                      title: "¡Operación Exitosa!",
                      text: "El registro se envio correctamente. ",
                      footer: "No. de Solicitud: " + id,
                    });
                    self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(id));
                    // self.$router.replace("/cartaporte");
                   // self.cargar();
                    self.$root.$dialogLoader.hide();
                   // self.regenera_json="";
                  }
                })
                .catch((error) => {
                  console.log(error);
                  self.$root.$dialogLoader.hide();
                  self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(''));
                  self.$swal({
                    type: "error",
                    title: "Error",
                    text: "Ocurrió un error al enviar el registro.",
                    footer: "Intente nuevamente mas tarde",
                  });
                  self.cargar();
                });

      },
      enviar: function(id) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;

        var data = {
          "id_solicitud": id,
        };
        axios.post(self.url + 'carta_porte/reintentar/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              console.log(res.data);
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se envio correctamente. ",
                footer: "No. de Solicitud: " + id,
              });
              self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(id));
              self.$router.replace("/cartaporte");
              self.$root.$dialogLoader.hide();
            }
          })
          .catch((error) => {
            console.log(error);
            self.$root.$dialogLoader.hide();
            self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(''));
            self.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al enviar el registro.",
              footer: "Intente nuevamente mas tarde",
            });
            self.cargar();
          });

      },
      regenerar: function(id) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;

        var data = {
          "id_solicitud": id,
        };
        axios.post(self.url + 'carta_porte/genera_pdf_mongo/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {
              console.log(res.data);
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se envio correctamente. ",
                footer: "No. de Solicitud: " + id,
              });
              self.$root.$dialogLoader.hide();
            }
          })
          .catch((error) => {
            console.log(error);
            self.$root.$dialogLoader.hide();
            self.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al enviar el registro.",
              footer: "Intente nuevamente mas tarde",
            });
          });

      },
      print: function(id) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var self = this;

        var data = {
          "id_solicitud": id,
        };
        axios.post(self.url + 'carta_porte/genera_pdf_mongo/', data)
          .then((res) => {
            if (typeof res.data !== 'undefined') {

              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se envio correctamente. ",
                footer: "No. de Solicitud: " + id,
              });

              self.$root.$dialogLoader.hide();
            }
          })
          .catch((error) => {
            console.log(error);

            self.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al enviar el registro.",
              footer: "",
            });
            self.$root.$dialogLoader.hide();
          });

      },
      cargarEmisor: async function() {
        let self = this;
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var params = {
          "filtros": {
            "uuid": self.id_empresa
          }
        };

        await this.$axios.post(this.url + "carta_porte/administracion/list_empresas/", params)
          .then(res => {
            if (res.data.length > 0) {
              self.emisor_completo = res.data[0];
              self.emisor = res.data[0].rfc;
              if (self.id_solicitud.length > 0) {
                this.params = {
                  "cliente": self.emisor,
                  "id_solicitud": self.id_solicitud
                }
              } else {
                this.params = {
                  "cliente": self.emisor
                }
                /*  if( this.permiso_editar && this.permiso_notas && this.permiso_pagos ){
                     this.params = {
                     "cliente": self.emisor
                   }
                 }else
                 if( !this.permiso_editar && !this.permiso_notas && this.permiso_pagos ){
                     this.params = {
                     "cliente": self.emisor,
                     "filtros": {
                         "json.TipoDeComprobante": "P"
                     }
                   }
                 }else
                 if( !this.permiso_editar && this.permiso_notas && !this.permiso_pagos ){
                     this.params = {
                     "cliente": self.emisor,
                     "filtros": {
                         "json.TipoDeComprobante": "E"
                     }
                   }
                 }
                 else
                 if( this.permiso_editar && !this.permiso_notas && !this.permiso_pagos ){
                     this.params = {
                     "cliente": self.emisor,
                     "filtros": {
                         "json.TipoDeComprobante": "I"
                     }
                   }
                 }else
                 if( !this.permiso_editar && this.permiso_notas && this.permiso_pagos ){
                     this.params = {
                     "cliente": self.emisor,
                     "filtros": {
                         "json.TipoDeComprobante": {$ne:"I"}
                     }
                   }
                 }else
                 if( this.permiso_editar && !this.permiso_notas && this.permiso_pagos ){
                     this.params = {
                     "cliente": self.emisor,
                     "filtros": {
                         "json.TipoDeComprobante": {$ne:"E"}
                     }
                   }
                 }else
                 if( this.permiso_editar && this.permiso_notas && !this.permiso_pagos ){
                     this.params = {
                     "cliente": self.emisor,
                     "filtros": {
                         "json.TipoDeComprobante": {$ne:"P"}
                     }
                   }
                 }; */
              }
              self.cargar();
            } else {
              self.$swal({
                type: "error",
                title: "Error",
                text: "No se encontro la empresa.",
                footer: "",
              });
            }
          })
          .catch(err => {
            self.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al obtener los registros.",
              footer: "",
            });
            console.log(err);
          }).then(() => {
            self.$root.$dialogLoader.hide();
          });
      },
      mostrar_correo: function(id_solicitud, rfc, json) {


        var self = this;
        self.id_solicitud_correo = id_solicitud;

        self.$root.$dialogLoader.show("Espere un momento por favor..");

        var paramsCliente = {
          rfc: json.Receptor.Rfc,
          uuid_empresa: this.id_empresa,
        };

        var params = {
          filtros: {
            rfc: rfc,
          }
        };

        this.$axios.post(this.url + "carta_porte/administracion/list_empresas/", params)
          .then(res => {
            self.correo.correos = [];
            if (typeof res.data !== "undefined" && res.data.length > 0) {
              if (res.data[0].email != undefined) {
                self.correo_cliente = res.data[0].email;
                //    self.check_cliente = 1;
                //   self.set_correo_cliente();
              }
            }

            this.$axios.post(self.url + "carta_porte/catalogos/list_clientes/", paramsCliente)
              .then(res => {

                if (typeof res.data !== "undefined" && res.data.length > 0) {

                  if (res.data[0].email != undefined && res.data[0].email != "") {

                    self.correo_receptor = res.data[0].email;
                    this.correo.asunto = self.empresa + " [ Factura: " + json.Serie.trim() + "-" + json.Folio + " ]";
                    self.check_receptor = 1;
                    self.set_correo_receptor();
                  }
                }

              })
              .catch(err => {
                console.log(err);
              });


          })
          .catch(err => {
            self.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al obtener los registros.",
              footer: "",
            });
            console.log(err);
          }).then(() => {
            self.$root.$dialogLoader.hide();
            self.modalCorreo = true;
          });

      },
      enviarCorreo: function() {
        if (this.$refs.formcorreo.validate()) {
          var self = this;

          self.$root.$dialogLoader.show("Espere un momento por favor..");

          var data = {
            id_solicitud: this.id_solicitud_correo, //requerido
            lista_emails: this.correo.correos.replaceAll(" ", "").split(","), //requerido, debe ser un array
            asunto: this.correo.asunto, //opcional
            mensaje: this.correo.mensaje, //opcional
            responder_a: this.correo.responder_a, //opcional
          };

          let url = this.url + 'carta_porte/enviar_factura/';
          axios.post(url, data)
            .then((res) => {
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El correo se envió correctamente.",
                footer: ""
              });
            })
            .catch((error) => {
              self.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al enviar el correo. Por favor intente nuevamente.",
                footer: ""
              });
              console.log("error al enviar correo", error);
            }).then(() => {
              self.$root.$dialogLoader.hide();
              this.modalCorreo = false;
            });

        }
      },
      valida_correo: function(mail) {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(mail);
      },
      validaFolio: function(val) {
        const pattern = /^[a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$/;
        if (pattern.test(val)) {
          return true;
        } else {
          return "Folio mal formado";
        }
      },
      validaCorreo: function(val) {
        if (val != null && val != "") {
          var correos = val.split(",");
          for (var k in correos) {
            var correo = correos[k].toString().trim();
            if (!this.valida_correo(correo)) {
              return "Hay un correo no valido. Favor de verificar.";
              break;
            }
          }
        }
        return true;
      },
      isString: function(obj) {
        return Object.prototype.toString.call(obj) === '[object String]';
      },
      set_correo_receptor: function() {
        var self = this;

        if (this.check_receptor == 1) {
          if (this.correo_receptor != "") {
            if (self.isString(self.correo.correos)) {
              self.correo.correos = self.correo.correos.replaceAll(" ", "").split(","); //hacemos array
            }
            if (self.correo.correos[0] == "") {
              self.correo.correos = [];
            }
            //console.log(self.correo.correos);
            self.correo.correos.push(this.correo_receptor);
            self.correo.correos = self.correo.correos.join(",");
          } else {
            self.$swal({
              type: "info",
              title: "Cuidado",
              text: "No se ha dado de alta correo en información del receptor.",
              footer: "",
            }).then(() => {
              self.check_receptor = 0;
            });
          }
        } else {
          self.correo.correos = self.correo.correos.replaceAll(" ", "").replaceAll(this.correo_receptor + ",", "").replaceAll("," + this.correo_receptor, "").replaceAll(this.correo_receptor, "");
        }
      },
      set_correo_cliente: function() {
        var self = this;
        if (this.check_cliente == 1) {
          if (this.correo_cliente.length > 0) {
            if (self.isString(self.correo.correos)) {
              self.correo.correos = self.correo.correos.replaceAll(" ", "").split(","); //hacemos array
            }
            if (self.correo.correos[0] == "") {
              self.correo.correos = [];
            }
            self.correo.correos = [this.correo_cliente];
            self.correo.correos = self.correo.correos.join(",");
          } else {
            self.$swal({
              type: "info",
              title: "Cuidado",
              text: "No se han dado de alta correos en datos fiscales.",
              footer: "",
            }).then(() => {
              self.check_cliente = 0;
            });
          }
        }
      },
      handleSuccess: async function({
        results,
        header
      }) {
        var errores = 0;
        var erroresText = '';
        var importData = {};
        try {
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          var self = this;
          var cfdis = [];
          var aux = {
            "serie": "",
            "folio": ""
          };
          var aux_concepto = {
            "descripcion": "",
            "cantidad": "",
            "importe": ""
          };
          var concepto = {};

          // Se Valida que todos los rows tengan los datos obligatorios
          var valido = true;
          results.forEach((item) => {
            var keys = Object.keys(item);
            var no_requeridos = ['Observaciones', 'Total', 'Subtotal', 'Descuento', 'RetencionesImpuesto', 'RetecionesTipoFactor', 'RetencionesTasaOCuota', 'RetencionesBase', 'RetencionesImporte', 'DescuentoConcepto', 'TrasladosImpuesto', 'TrasladosTipoFactor',
              'TrasladosTasaOCuota', 'TrasladosBase', 'TrasladosImporte', 'NoIdentificacion'
            ];
            var requeridos = header.filter(x => !no_requeridos.includes(x));
            requeridos.forEach((item2) => {
              if (!keys.includes(item2)) {
                valido = false;
              }
            });

          });

          var factura = this.get_factura_nueva();
          let   total_calculado = 0;
          if (valido) {
            results.forEach((item, i) => {

               //if ((aux['folio'] != item['Folio'] || aux['serie'] != item['Serie']) && i > 0) {
               // cfdis.push(factura);
               // factura = this.get_factura_nueva();
               // total_calculado = 0;
             // }
              aux = {
                "serie": item['Serie'],
                "folio": item['Folio']
              };

              if(item['Subtotal'] != undefined)
              factura.SubTotal = item['Subtotal'].toString();
              if(item['Total'] != undefined)
              factura.Total = item['Total'].toString();
              factura.Serie = item['Serie'];
              factura.Folio = '';
              factura.Exportacion = item['Exportacion'].toString();
              factura.Fecha = moment().format("YYYY-MM-DD") + "T00:00:00";
              factura.Moneda = item['Moneda'];
              factura.LugarExpedicion = item['LugarExpedicion'].toString();
              factura.Observaciones = item['Observaciones'] != undefined ? item['Observaciones'] : "";
              factura.FormaPago = item['FormaPago'];
              factura.TipoCambio = item['TipoCambio'].toString();
              factura.MetodoPago = item['MetodoPago'];
              factura.Descuento = item['Descuento'] != undefined ? item['Descuento'].toString() : "0";
              factura.Receptor = {
                "Rfc": item['ReceptorRfc'],
                "Nombre": item['ReceptorNombre'],
                "UsoCFDI": item['ReceptorUsoCFDI'],
                "RegimenFiscalReceptor": item['ReceptorRegimenFiscal'].toString(),
                "DomicilioFiscalReceptor": item['ReceptorDomicilioFiscal'].toString(),
              };
              if(item['ReceptorNombre'] == 'GLOBAL'){
                  factura.Receptor.Nombre = "PUBLICO EN GENERAL";
                  factura.InformacionGlobal= {
                          "Periodicidad": "02",
                          "Meses": item['Fecha'].substring(5).substring(0, 2),
                          "Año": item['Fecha'].substring(0, 4)
                        }
              }


              //Verificar que es un nuevo concepto si no solo agregar sus impuestos
              if (aux_concepto['NoIdentificacion'] != item['NoIdentificacion'] || aux_concepto['descripcion'] != item['Descripcion'] || aux_concepto['cantidad'] != item['Cantidad'] || aux_concepto['importe'] != item['Importe']) {
                let concepto = {
                  "Cantidad": item['Cantidad'].toString(),
                  "ClaveProdServ": item['ClaveProdServ'].toString(),
                  "ObjetoImp": item['ObjetoImp'].toString(),
                  "ClaveUnidad": item['ClaveUnidad'].toString(),
                  "Descripcion": item['Descripcion'].toString(),
                  "Importe": item['Importe'].toString(),
                  "ValorUnitario": item['ValorUnitario'].toString(),
                  "Descuento": item['DescuentoConcepto'] != undefined ? item['DescuentoConcepto'].toString() : "0",
                  "NoIdentificacion": item['NoIdentificacion'] != undefined ? item['NoIdentificacion'].toString() : undefined
                };
                total_calculado += parseFloat(item['Importe'].toFixed(4));
                if (item['ObjetoImp'] == '02') {
                  concepto.Impuestos = {};

                  if (item['TrasladosImpuesto'] != undefined) {
                    concepto.Impuestos.Traslados = [{
                      "Impuesto": item['TrasladosImpuesto'],
                      "TipoFactor": item['TrasladosTipoFactor'] != undefined ? item['TrasladosTipoFactor'] : "",
                      "TasaOCuota": item['TrasladosTasaOCuota'] != undefined ? item['TrasladosTasaOCuota'] : "",
                      "Base": item['TrasladosBase'] != undefined ? item['TrasladosBase'] : "",
                      "Importe": item['TrasladosImporte'] != undefined ? item['TrasladosImporte'] : ""
                    }];
                  }

                  if (item['RetencionesImpuesto'] != undefined) {
                    concepto.Impuestos.Retenciones = [{
                      "Impuesto": item['RetencionesImpuesto'],
                      "TipoFactor": item['RetencionesTipoFactor'] != undefined ? item['RetencionesTipoFactor'] : "",
                      "TasaOCuota": item['RetencionesTasaOCuota'] != undefined ? item['RetencionesTasaOCuota'] : "",
                      "Base": item['RetencionesBase'] != undefined ? item['RetencionesBase'] : "",
                      "Importe": item['RetencionesImporte'] != undefined ? item['RetencionesImporte'] : ""
                    }];
                  }

                } else {
                  concepto.Impuestos = null;
                }

                factura.Conceptos.push(concepto)
              } else {
                if (item['ObjetoImp'] == '02') {
                  let search_concepto = factura.Conceptos.filter(x =>  x.NoIdentificacion == item['NoIdentificacion'] && x.Descripcion == item['Descripcion'] && x.Importe == item['Importe'] && x.Cantidad == item.Cantidad)

                  if (search_concepto.length > 0) {
                    search_concepto = search_concepto[0];

                    if (item['TrasladosImpuesto'] != undefined) {
                      if (search_concepto.Impuestos.Traslados != undefined) {
                        let impuesto = '003'
                          if(parseFloat(item['TrasladosTasaOCuota']) == 0 || parseFloat(item['TrasladosTasaOCuota']) == 0.16){
                            impuesto = '002'
                          }
                        search_concepto.Impuestos.Traslados.push({
                          "Impuesto": impuesto,
                          "TipoFactor": item['TrasladosTipoFactor'] != undefined ? item['TrasladosTipoFactor'] : "",
                          "TasaOCuota": item['TrasladosTasaOCuota'] != undefined ? item['TrasladosTasaOCuota'] : "",
                          "Base": item['TrasladosBase'] != undefined ? item['TrasladosBase'] : "",
                          "Importe": item['TrasladosImporte'] != undefined ? item['TrasladosImporte'] : ""
                        });
                      } else {
                        search_concepto.Impuestos.Traslados = [{
                          "Impuesto": impuesto,
                          "TipoFactor": item['TrasladosTipoFactor'] != undefined ? item['TrasladosTipoFactor'] : "",
                          "TasaOCuota": item['TrasladosTasaOCuota'] != undefined ? item['TrasladosTasaOCuota'] : "",
                          "Base": item['TrasladosBase'] != undefined ? item['TrasladosBase'] : "",
                          "Importe": item['TrasladosImporte'] != undefined ? item['TrasladosImporte'] : ""
                        }];
                      }
                    }

                    if (item['RetencionesImpuesto'] != undefined) {
                      if (search_concepto.Impuestos.Retenciones != undefined) {
                        search_concepto.Impuestos.Retenciones.push({
                          "Impuesto": item['RetencionesImpuesto'],
                          "TipoFactor": item['RetencionesTipoFactor'] != undefined ? item['RetencionesTipoFactor'] : "",
                          "TasaOCuota": item['RetencionesTasaOCuota'] != undefined ? item['RetencionesTasaOCuota'] : "",
                          "Base": item['RetencionesBase'] != undefined ? item['RetencionesBase'] : "",
                          "Importe": item['RetencionesImporte'] != undefined ? item['RetencionesImporte'] : ""
                        });
                      } else {
                        search_concepto.Impuestos.Retenciones = [{
                          "Impuesto": item['RetencionesImpuesto'],
                          "TipoFactor": item['RetencionesTipoFactor'] != undefined ? item['RetencionesTipoFactor'] : "",
                          "TasaOCuota": item['RetencionesTasaOCuota'] != undefined ? item['RetencionesTasaOCuota'] : "",
                          "Base": item['RetencionesBase'] != undefined ? item['RetencionesBase'] : "",
                          "Importe": item['RetencionesImporte'] != undefined ? item['RetencionesImporte'] : ""
                        }];
                      }
                    }

                  }
                }
              }

              aux_concepto = {
                "NoIdentificacion": item['NoIdentificacion'],
                "descripcion": item['Descripcion'],
                "cantidad": item['Cantidad'],
                "importe": item['Importe']
              };
              if (i == results.length - 1) {
                cfdis.push(factura);
              }
            });
          } else {
            self.$swal({
              type: "error",
              title: "Error",
              text: "Debes llenar correctamente todos los campos obligatorios en el Layout",
              footer: "",
            });
            self.$root.$dialogLoader.hide();
            return;
          }
          let impuestos = 0;
          //Se agregan los Impuestos Generales
          cfdis.forEach((fac) => {
            let impuesto_general = {
              "Traslados": [],
              "Retenciones": [],
              "TotalImpuestosRetenidos": 0,
              "TotalImpuestosTrasladados": 0
            };

            fac.Conceptos.forEach((con) => {
              if (con.Impuestos != undefined && con.Impuestos != null) {
                if (con.Impuestos.Traslados != null && con.Impuestos.Traslados != undefined) {
                  con.Impuestos.Traslados.forEach((tas) => {

                    impuesto_general.TotalImpuestosTrasladados += parseFloat(tas.Importe.toFixed(6));

                    var existe = impuesto_general.Traslados.filter(z => z.Impuesto == tas.Impuesto && z.TipoFactor == tas.TipoFactor && z.TasaOCuota == tas.TasaOCuota)
                    if (existe.length > 0) {
                      existe = existe[0];
                      existe.Base += parseFloat(tas.Base.toFixed(6));
                      existe.Importe += parseFloat(tas.Importe.toFixed(6));
                    } else {
                      let clone = Object.assign({},tas);
                      impuesto_general.Traslados.push(clone);
                    }
                  });
                }

                if (con.Impuestos.Retenciones != null && con.Impuestos.Retenciones != undefined) {
                  con.Impuestos.Retenciones.forEach((ret) => {
                    impuesto_general.TotalImpuestosRetenidos += parseFloat(ret.Importe.toFixed(6));

                    var existe = impuesto_general.Retenciones.filter(z => z.Impuesto == ret.Impuesto)
                    if (existe.length > 0) {
                      existe = existe[0];
                      existe.Importe += parseFloat(ret.Importe.toFixed(6));
                    } else {
                      impuesto_general.Retenciones.push({
                        "Impuesto": ret.Impuesto,
                        "Importe": ret.Importe
                      });
                    }
                  });
                }
              }
            });

            if (impuesto_general.Retenciones.length == 0) {
              delete impuesto_general.Retenciones;
            }

            if (impuesto_general.Traslados.length == 0) {
              delete impuesto_general.Traslados;
            }

            fac.Impuestos = impuesto_general;
            impuestos = impuesto_general.TotalImpuestosTrasladados + impuesto_general.TotalImpuestosRetenidos;
             fac['SubTotal'] = total_calculado.toFixed(2);
             fac['Total'] = (total_calculado + impuesto_general.TotalImpuestosTrasladados - impuesto_general.TotalImpuestosRetenidos).toFixed(2);
          });

          //Se hacen strings los valores faltantes
          cfdis.forEach((fac) => {
            if (fac.Impuestos != null && fac.Impuestos != undefined) {
              fac.Impuestos.TotalImpuestosRetenidos = fac.Impuestos.TotalImpuestosRetenidos.toFixed(2);
              fac.Impuestos.TotalImpuestosTrasladados = fac.Impuestos.TotalImpuestosTrasladados.toFixed(2);

              if (fac.Impuestos.Traslados != undefined) {
                fac.Impuestos.Traslados.forEach((tas) => {
                  tas.Base = tas.Base.toFixed(2);
                  tas.Importe = parseFloat(tas.Importe).toFixed(2);
                  tas.TasaOCuota = tas.TasaOCuota.toString();
                });

              }

              if (fac.Impuestos.Retenciones != undefined) {
                fac.Impuestos.Retenciones.forEach((ret) => {
                  ret.Importe = parseFloat(ret.Importe).toFixed(2);
                });
              }
            }

            fac.Conceptos.forEach((con) => {
              if (con.Impuestos != undefined && con.Impuestos != null) {
                if (con.Impuestos.Traslados != undefined) {
                  con.Impuestos.Traslados.forEach((tas) => {
                    tas.Base = tas.Base.toFixed(2);
                    tas.Importe = tas.Importe.toFixed(2);
                    tas.TasaOCuota = tas.TasaOCuota.toString();
                  });
                }

                if (con.Impuestos.Retenciones != undefined) {
                  con.Impuestos.Retenciones.forEach((ret) => {
                    ret.Base = ret.Base.toFixed(2);
                    ret.Importe = ret.Importe.toFixed(2);
                    ret.TasaOCuota = ret.TasaOCuota.toString();
                  });
                }
              }
            });

          });

          if (cfdis.length > 0) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
              "rfc": self.emisor,
              "cfdis": cfdis
            };
            axios.post(self.url + 'carta_porte/guardar_layout_cfdi/', data)
              .then((res) => {
                self.$swal({
                  type: "success",
                  title: "¡Operación Exitosa!",
                  text: "El registro se envio correctamente. ",
                  footer: "",
                });
              })
              .catch((error) => {
                console.log(error);
                self.$swal({
                  type: "error",
                  title: "Error",
                  text: "Algunos CFDI's no se guardaron",
                  footer: "",
                });
              }).then(() => {
                self.$root.$dialogLoader.hide();
                self.cargar()
              });

          } else {
            self.$swal({
              type: "error",
              title: "Error",
              text: "No se genero ningún CFDI",
              footer: "",
            });
            self.$root.$dialogLoader.hide();
            return;
          }
        } catch (e) {
          self.$swal({
            type: "error",
            title: "Error",
            text: "No se genero ningún CFDI" + e,
            footer: "",
          });
          this.$root.$dialogLoader.hide();
          return;
        }

      },
      handleSuccess2: async function({
        results,
        header
      }) {
        var errores = 0;
        var erroresText = '';
        var importData = {};
        var Conceptos = [];
        this.cfdis = [];
        try {
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          var self = this;

          var aux = {
            "serie": "",
            "folio": ""
          };
          var aux_concepto = {
            "descripcion": "",
            "cantidad": "",
            "importe": ""
          };
          var concepto = {};

          // Se Valida que todos los rows tengan los datos obligatorios
          var valido = true;
          results.forEach((item) => {
            var keys = Object.keys(item);
            var no_requeridos = ['Observaciones', 'Total', 'Subtotal', 'Descuento', 'RetencionesImpuesto', 'RetecionesTipoFactor', 'RetencionesTasaOCuota', 'RetencionesBase', 'RetencionesImporte', 'DescuentoConcepto', 'TrasladosImpuesto', 'TrasladosTipoFactor',
              'TrasladosTasaOCuota', 'TrasladosBase', 'TrasladosImporte', 'NoIdentificacion'
            ];
            var requeridos = header.filter(x => !no_requeridos.includes(x));
            requeridos.forEach((item2) => {
              if (!keys.includes(item2)) {
                valido = false;
              }
            });

          });

          var factura = this.get_factura_nueva_e();
          let   total_calculado = 0;
          if (valido) {
            results.forEach((item, i) => {

              if ((aux['folio'] != item['Folio'] || aux['serie'] != item['Serie']) && i > 0) {
                self.cfdis.push(factura);
                factura = this.get_factura_nueva_e();
                total_calculado = 0;
              }
              aux = {
                "serie": item['Serie'],
                "folio": item['Folio']
              };

              if(item['Subtotal'] != undefined)
              factura.SubTotal = item['Subtotal'].toString();
              if(item['Total'] != undefined)
              factura.Total = item['Total'].toString();
              factura.Serie = "";
              factura.Folio = "";
              factura.Exportacion = item['Exportacion'].toString();
              factura.Fecha =  moment().format("YYYY-MM-DD").toString() + "T00:00:00";
              factura.Moneda = item['Moneda'];
              factura.LugarExpedicion = item['LugarExpedicion'].toString();
              factura.Observaciones = item['Observaciones'] != undefined ? item['Observaciones'] : "";
              factura.FormaPago = item['FormaPago'];
              factura.TipoCambio = item['TipoCambio'].toString();
              factura.MetodoPago = item['MetodoPago'];
              factura.Descuento = item['Descuento'] != undefined ? item['Descuento'].toString() : "0";
              factura.Receptor = self.r_actual.Receptor;
              factura.Receptor.DomicilioFiscalReceptor = item['LugarExpedicion'].toString();
              factura.CfdiRelacionados=
                      [{"TipoRelacion":'01',
                       "UUIDS":[self.r_actual.Complemento.TimbreFiscalDigital.UUID]}];

              factura.Conceptos= [{
                          "Cantidad": "1",
                          "ClaveProdServ": "84111506",
                          "ClaveUnidad": "ACT",
                          "Descripcion": "Nota",
                          "Importe": "",
                          "ValorUnitario": "",
                          "ObjetoImp": "02",
                          "Descuento":"0",
                          "Impuestos": {}}
                  ];
              //Verificar que es un nuevo concepto si no solo agregar sus impuestos
              if (aux_concepto['NoIdentificacion'] != item['NoIdentificacion'] || aux_concepto['descripcion'] != item['Descripcion'] || aux_concepto['cantidad'] != item['Cantidad'] || aux_concepto['importe'] != item['Importe']) {
                let concepto = {
                  "Cantidad": item['Cantidad'].toString(),
                  "ClaveProdServ": item['ClaveProdServ'].toString(),
                  "ObjetoImp": item['ObjetoImp'].toString(),
                  "ClaveUnidad": item['ClaveUnidad'].toString(),
                  "Descripcion": item['Descripcion'].toString(),
                  "Importe": item['Importe'].toString(),
                  "ValorUnitario": item['ValorUnitario'].toString(),
                  "Descuento": item['DescuentoConcepto'] != undefined ? item['DescuentoConcepto'].toString() : "0",
                  "NoIdentificacion": item['NoIdentificacion'] != undefined ? item['NoIdentificacion'].toString() : undefined
                };
                total_calculado += parseFloat(item['Importe']);
                if (item['ObjetoImp'] == '02') {
                  concepto.Impuestos = {};

                  if (item['TrasladosImpuesto'] != undefined) {
                    concepto.Impuestos.Traslados = [{
                      "Impuesto": item['TrasladosImpuesto'],
                      "TipoFactor": item['TrasladosTipoFactor'] != undefined ? item['TrasladosTipoFactor'] : "",
                      "TasaOCuota": item['TrasladosTasaOCuota'] != undefined ? item['TrasladosTasaOCuota'] : "",
                      "Base": item['TrasladosBase'] != undefined ? item['TrasladosBase'] : "",
                      "Importe": item['TrasladosImporte'] != undefined ? item['TrasladosImporte'] : ""
                    }];
                  }

                  if (item['RetencionesImpuesto'] != undefined) {
                    concepto.Impuestos.Retenciones = [{
                      "Impuesto": item['RetencionesImpuesto'],
                      "TipoFactor": item['RetencionesTipoFactor'] != undefined ? item['RetencionesTipoFactor'] : "",
                      "TasaOCuota": item['RetencionesTasaOCuota'] != undefined ? item['RetencionesTasaOCuota'] : "",
                      "Base": item['RetencionesBase'] != undefined ? item['RetencionesBase'] : "",
                      "Importe": item['RetencionesImporte'] != undefined ? item['RetencionesImporte'] : ""
                    }];
                  }

                } else {
                  concepto.Impuestos = null;
                }

                Conceptos.push(concepto);
              } else {
                if (item['ObjetoImp'] == '02') {
                  let search_concepto = Conceptos.filter(x =>  x.NoIdentificacion == item['NoIdentificacion'] && x.Descripcion == item['Descripcion'] && x.Importe == item['Importe'] && x.Cantidad == item.Cantidad)

                  if (search_concepto.length > 0) {
                    search_concepto = search_concepto[0];

                    if (item['TrasladosImpuesto'] != undefined) {
                      if (search_concepto.Impuestos.Traslados != undefined) {
                        search_concepto.Impuestos.Traslados.push({
                          "Impuesto": item['TrasladosImpuesto'],
                          "TipoFactor": item['TrasladosTipoFactor'] != undefined ? item['TrasladosTipoFactor'] : "",
                          "TasaOCuota": item['TrasladosTasaOCuota'] != undefined ? item['TrasladosTasaOCuota'] : "",
                          "Base": item['TrasladosBase'] != undefined ? item['TrasladosBase'] : "",
                          "Importe": item['TrasladosImporte'] != undefined ? item['TrasladosImporte'] : ""
                        });
                      } else {
                        search_concepto.Impuestos.Traslados = [{
                          "Impuesto": item['TrasladosImpuesto'],
                          "TipoFactor": item['TrasladosTipoFactor'] != undefined ? item['TrasladosTipoFactor'] : "",
                          "TasaOCuota": item['TrasladosTasaOCuota'] != undefined ? item['TrasladosTasaOCuota'] : "",
                          "Base": item['TrasladosBase'] != undefined ? item['TrasladosBase'] : "",
                          "Importe": item['TrasladosImporte'] != undefined ? item['TrasladosImporte'] : ""
                        }];
                      }
                    }

                    if (item['RetencionesImpuesto'] != undefined) {
                      if (search_concepto.Impuestos.Retenciones != undefined) {
                        search_concepto.Impuestos.Retenciones.push({
                          "Impuesto": item['RetencionesImpuesto'],
                          "TipoFactor": item['RetencionesTipoFactor'] != undefined ? item['RetencionesTipoFactor'] : "",
                          "TasaOCuota": item['RetencionesTasaOCuota'] != undefined ? item['RetencionesTasaOCuota'] : "",
                          "Base": item['RetencionesBase'] != undefined ? item['RetencionesBase'] : "",
                          "Importe": item['RetencionesImporte'] != undefined ? item['RetencionesImporte'] : ""
                        });
                      } else {
                        search_concepto.Impuestos.Retenciones = [{
                          "Impuesto": item['RetencionesImpuesto'],
                          "TipoFactor": item['RetencionesTipoFactor'] != undefined ? item['RetencionesTipoFactor'] : "",
                          "TasaOCuota": item['RetencionesTasaOCuota'] != undefined ? item['RetencionesTasaOCuota'] : "",
                          "Base": item['RetencionesBase'] != undefined ? item['RetencionesBase'] : "",
                          "Importe": item['RetencionesImporte'] != undefined ? item['RetencionesImporte'] : ""
                        }];
                      }
                    }

                  }
                }
              }

              aux_concepto = {
                "NoIdentificacion": item['NoIdentificacion'],
                "descripcion": item['Descripcion'],
                "cantidad": item['Cantidad'],
                "importe": item['Importe']
              };
              if (i == results.length - 1) {
                self.cfdis.push(factura);
              }
            });
          } else {
            self.$swal({
              type: "error",
              title: "Error",
              text: "Debes llenar correctamente todos los campos obligatorios en el Layout",
              footer: "",
            });
            self.$root.$dialogLoader.hide();
            return;
          }
          let impuestos = 0;
          //Se agregan los Impuestos Generales
          self.cfdis.forEach((fac) => {
            let impuesto_general = {
              "Traslados": [],
              "Retenciones": [],
              "TotalImpuestosRetenidos": 0,
              "TotalImpuestosTrasladados": 0
            };

            Conceptos.forEach((con) => {
              if (con.Impuestos != undefined && con.Impuestos != null) {
                if (con.Impuestos.Traslados != null && con.Impuestos.Traslados != undefined) {
                  con.Impuestos.Traslados.forEach((tas) => {

                    impuesto_general.TotalImpuestosTrasladados += parseFloat(tas.Importe.toFixed(4));

                    var existe = impuesto_general.Traslados.filter(z => z.Impuesto == tas.Impuesto && z.TipoFactor == tas.TipoFactor && z.TasaOCuota == tas.TasaOCuota)
                    if (existe.length > 0) {
                      existe = existe[0];
                      existe.Base += parseFloat(tas.Base.toFixed(4));
                      existe.Importe += parseFloat(tas.Importe.toFixed(4));
                    } else {
                      let clone = Object.assign({},tas);
                      impuesto_general.Traslados.push(clone);
                    }
                  });
                }

                if (con.Impuestos.Retenciones != null && con.Impuestos.Retenciones != undefined) {
                  con.Impuestos.Retenciones.forEach((ret) => {
                    impuesto_general.TotalImpuestosRetenidos += parseFloat(ret.Importe.toFixed(4));

                    var existe = impuesto_general.Retenciones.filter(z => z.Impuesto == ret.Impuesto)
                    if (existe.length > 0) {
                      existe = existe[0];
                      existe.Importe += parseFloat(ret.Importe.toFixed(4));
                    } else {
                      impuesto_general.Retenciones.push({
                        "Impuesto": ret.Impuesto,
                        "Importe": ret.Importe
                      });
                    }
                  });
                }
              }
            });

            if (impuesto_general.Retenciones.length == 0) {
              delete impuesto_general.Retenciones;
            }

            if (impuesto_general.Traslados.length == 0) {
              delete impuesto_general.Traslados;
            }

            let imp =  {...impuesto_general};
            fac.Conceptos[0].Impuestos = impuesto_general ;

            fac.Impuestos = imp;
            impuestos = impuesto_general.TotalImpuestosTrasladados + impuesto_general.TotalImpuestosRetenidos;
             fac['SubTotal'] = total_calculado.toFixed(2);
             fac['Total'] = (total_calculado + impuesto_general.TotalImpuestosTrasladados - impuesto_general.TotalImpuestosRetenidos).toFixed(2);
             fac.Conceptos[0].Importe = fac['SubTotal'];
             fac.Conceptos[0].ValorUnitario = fac['SubTotal'];



          });

          //Se hacen strings los valores faltantes
          self.cfdis.forEach((fac) => {
            if (fac.Impuestos != null && fac.Impuestos != undefined) {
              fac.Impuestos.TotalImpuestosRetenidos = fac.Impuestos.TotalImpuestosRetenidos.toFixed(2);
              fac.Impuestos.TotalImpuestosTrasladados = fac.Impuestos.TotalImpuestosTrasladados.toFixed(2);

              if (fac.Impuestos.Traslados != undefined) {
                fac.Impuestos.Traslados.forEach((tas) => {
                  tas.Base = parseFloat(tas.Base).toFixed(2);
                  tas.Importe = parseFloat(tas.Importe).toFixed(2);
                  tas.TasaOCuota = tas.TasaOCuota.toString();
                });

              }

              if (fac.Impuestos.Retenciones != undefined) {
                fac.Impuestos.Retenciones.forEach((ret) => {
                  ret.Importe = parseFloat(ret.Importe).toFixed(2);
                });
              }
            }

            fac.Conceptos.forEach((con) => {
              if (con.Impuestos != undefined && con.Impuestos != null) {
                if (con.Impuestos.Traslados != undefined) {
                  con.Impuestos.Traslados.forEach((tas) => {
                    tas.Base =  parseFloat(tas.Base).toFixed(2);
                    tas.Importe = parseFloat(tas.Importe).toFixed(2);
                    tas.TasaOCuota = tas.TasaOCuota.toString();
                  });
                }

                if (con.Impuestos.Retenciones != undefined) {
                  con.Impuestos.Retenciones.forEach((ret) => {
                    ret.Base = parseFloat(ret.Base).toFixed(2);
                    ret.Importe = parseFloat(ret.Importe).toFixed(2);
                    ret.TasaOCuota = ret.TasaOCuota.toString();
                  });
                }
              }
            });

          });
           delete self.cfdis[0].Conceptos[0].Impuestos.TotalImpuestosRetenidos;
           delete self.cfdis[0].Conceptos[0].Impuestos.TotalImpuestosTrasladados;
           if(self.cfdis[0].Receptor.Rfc=="XAXX010101000"){
            self.cfdis[0].Receptor.Nombre = "PÚBLICO EN GENERAL";
           }
           if(parseFloat(self.cfdis[0].Total) == parseFloat(self.cfdis[0].SubTotal) ){
                self.cfdis[0].Conceptos[0].ObjetoImp = '01';
                delete self.cfdis[0].Conceptos[0].Impuestos;
             }
          if (self.cfdis.length > 0  ) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
              "rfc": self.emisor,
              "cfdis": self.cfdis
            };
            axios.post(self.url + 'carta_porte/guardar_layout_cfdi/', data)
              .then((res) => {
                self.$swal({
                  type: "success",
                  title: "¡Operación Exitosa!",
                  text: "El registro se envio correctamente. ",
                  footer: "",
                });
              })
              .catch((error) => {
                console.log(error);
                self.$swal({
                  type: "error",
                  title: "Error",
                  text: "Algunos CFDI's no se guardaron",
                  footer: "",
                });
              }).then(() => {
                self.$root.$dialogLoader.hide();
                self.cargar()
              });

          } else {
            self.$swal({
              type: "error",
              title: "Error",
              text: "No se genero ningún CFDI",
              footer: "",
            });
            self.$root.$dialogLoader.hide();
            return;
          }
        } catch (e) {
          self.$swal({
            type: "error",
            title: "Error",
            text: "No se genero ningún CFDI" + e,
            footer: "",
          });
          this.$root.$dialogLoader.hide();
          return;
        }

      },
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (isLt2M) {
          return true;
        }
        this.$swal({
          type: "warning",
          title: "¡Operación no Permitida!",
          text: "El archivo no debe ser mayor a 2MB.",
          footer: ""
        });
        return false;
      },

      ExcelDateToJSDate: function(serial) {
        var utc_days = Math.floor(serial - 25569);
        var utc_value = utc_days * 86400;
        var date_info = new Date(utc_value * 1000).toISOString().substring(0, 10);
        var procesada = date_info + "T00:00:00";

        return procesada;
      },
      get_factura_nueva: function() {
        return {
          "Version": "4.0",
          "SubTotal": "",
          "Total": "",
          "Serie": "",
          "Folio": "",
          "Exportacion": "",
          "Fecha": "",
          "Moneda": "",
          "TipoDeComprobante": "I",
          "LugarExpedicion": "",
          "Emisor": {
            "Nombre": this.emisor_completo.razon_social,
            "RegimenFiscal": this.emisor_completo.regimen,
            "Rfc": this.emisor_completo.rfc,
            "Domicilio": {
              "Calle": this.emisor_completo.domicilio.calle,
              "CodigoPostal": this.emisor_completo.domicilio.codigo_postal,
              "Colonia": this.emisor_completo.domicilio.colonia,
              "Estado": this.emisor_completo.domicilio.estado,
              "Localidad": this.emisor_completo.domicilio.localidad,
              "Municipio": this.emisor_completo.domicilio.municipio,
              "NumeroExterior": this.emisor_completo.domicilio.numero_ext,
              "Pais": this.emisor_completo.domicilio.pais,
              "Referencia": ""
            },
          },
          "Receptor": {
            "Rfc": "",
            "Nombre": "",
            "UsoCFDI": "",
            "RegimenFiscalReceptor": "",
            "DomicilioFiscalReceptor": ""
          },
          "Conceptos": [],
          "Observaciones": "",
          "FormaPago": "",
          "TipoCambio": "",
          "MetodoPago": "",
          "Descuento": ""
        };
      },
       get_factura_nueva_e: function() {
        return {
          "Version": "4.0",
          "SubTotal": "",
          "Total": "",
          "Serie": "",
          "Folio": "",
          "Exportacion": "",
          "Fecha": "",
          "Moneda": "",
          "TipoDeComprobante": "E",
          "LugarExpedicion": "",
          "Emisor": {
            "Nombre": this.emisor_completo.razon_social,
            "RegimenFiscal": this.emisor_completo.regimen,
            "Rfc": this.emisor_completo.rfc,
            "Domicilio": {
              "Calle": this.emisor_completo.domicilio.calle,
              "CodigoPostal": this.emisor_completo.domicilio.codigo_postal,
              "Colonia": this.emisor_completo.domicilio.colonia,
              "Estado": this.emisor_completo.domicilio.estado,
              "Localidad": this.emisor_completo.domicilio.localidad,
              "Municipio": this.emisor_completo.domicilio.municipio,
              "NumeroExterior": this.emisor_completo.domicilio.numero_ext,
              "Pais": this.emisor_completo.domicilio.pais,
              "Referencia": ""
            },
          },
          "Receptor": {
            "Rfc": "",
            "Nombre": "",
            "UsoCFDI": "",
            "RegimenFiscalReceptor": "",
            "DomicilioFiscalReceptor": ""
          },
          "Conceptos": [],
          "Observaciones": "",
          "FormaPago": "",
          "TipoCambio": "",
          "MetodoPago": "",
          "Descuento": ""
        };
      },
      consultar_estatus_cfdi: function(id_solicitud) {
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          var self = this;

          var data = {
            "id_solicitud": id_solicitud,
          };
          axios.post(self.url + 'carta_porte/consultar_estatus_mongo/', data)
            .then((res) => {
              if (typeof res.data !== 'undefined') {
                console.log(res.data);
                var tipo = "success";
                var titulo = "¡Operación Exitosa!";
                if(res.data.estatus_cancelacion == null){
                  res.data.estatus_cancelacion="Sin Respuesta, Intente nuevamente mas tarde o vuelva a enviarlo cancelar";
                  titulo = "Operación no permitida";
                  tipo="warning"

                }

                self.$swal({
                  type: tipo,
                  title: titulo,
                  text: res.data.estado,
                  footer: "Estatus: " + res.data.estatus_cancelacion,
                });
                self.$root.$dialogLoader.hide();
              }
            })
            .catch((error) => {
              console.log(error);
              self.$root.$dialogLoader.hide();
              self.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al consultar el registro.",
                footer: "Intente nuevamente mas tarde",
              });
            }).then(() => {
              self.cargar();
            });
        },
        open_modal_cancelado: function(id_solicitud) {
          this.$root.$dialogLoader.show("Espere un momento por favor..");
          var self = this;

          var data = {
            "id_solicitud": id_solicitud,
          };
          axios.post(self.url + 'carta_porte/detalles_cancelacion/', data)
            .then((res) => {
              if (typeof res.data !== 'undefined') {
                self.$root.$dialogLoader.hide();
                self.model_detalles_cancelacion = res.data;
                self.modal_detalles_cancelacion = true;

              }
            })
            .catch((error) => {
              console.log(error)
              self.model_detalles_cancelacion = null;
              self.modal_detalles_cancelacion = false;
              self.$root.$dialogLoader.hide();
              self.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al consultar el registro.",
                footer: "Intente nuevamente mas tarde",
              });
            }).then(() => {

            });
        },
        get_motivo_cancelacion: function(motivo) {
          var existe = this.motivos.filter(x => x.clave == motivo);

          if (existe.length == 1) {
            return motivo + " - " + existe[0].nombre;
          } else {
            return "No encontrado";
          }
        }
    },
    created: async function() {

      let self = this;
      self.id_solicitud = self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("id_solicitud")));


      this.rules = this.$rules;
      this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
      this.id_empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));
      this.id_licencia = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_licencia")));
      this.compartir_clientes = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("compartir_clientes")));
      this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
      if (this.id_empresa != null && this.id_empresa != "") {

        var saldo = await this.$funciones.get_saldo(this.id_empresa);
        this.$local_storage.set("saldo", saldo);
        this.$store.state.instancia += saldo;
      } else {
        this.$local_storage.set("saldo", 0);
        this.$store.state.instancia += 0;
      }

      await this.getErroresWebservice();
      await this.cargarEmisor();


      this.pwPagination.links.url = this.url + "carta_porte/list_carta_porte/";
      this.pwPagination.options.filters.cliente = this.emisor;
    },
  };
  </script>

  <style scoped>
  .VueTables>>>thead th {
    white-space: normal !important;
  }

  .VueTables>>>tbody td {
    white-space: normal !important;
  }

  .footer-hide>>>.VuePagination {
    display: none;
  }

  .VuePagination__count {
    display: none !important;
  }
  </style>
